import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            平台特色
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            汗汗漫画的四大核心优势，每一项都为更好的阅读体验而生
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featureItems.map((item, idx) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/60 text-center group cursor-pointer transition-all duration-300 hover:scale-[1.03]"
            >
              <div
                className={`w-16 h-16 mx-auto rounded-2xl flex items-center justify-center mb-5 ${
                  idx === 0
                    ? 'bg-primary-100/70 text-primary-600'
                    : idx === 1
                      ? 'bg-accent-100/70 text-accent-600'
                      : idx === 2
                        ? 'bg-secondary-200/70 text-secondary-800'
                        : 'bg-primary-100/70 text-primary-600'
                }`}
              >
                <i className={`${item.icon} text-2xl`} />
              </div>
              <h3 className="font-semibold text-base text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}